/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/two_factor';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "multipass": {
        "nested": {
          "SecureContactDetails": {
            "fields": {
              "description": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "verifiedAt": {
                "type": "int64",
                "id": 4,
                "rule": "optional"
              },
              "updatedAt": {
                "type": "int64",
                "id": 5,
                "rule": "optional"
              },
              "createdAt": {
                "type": "int64",
                "id": 6,
                "rule": "optional"
              },
              "phone": {
                "type": "string",
                "id": 2
              },
              "email": {
                "type": "string",
                "id": 3
              }
            },
            "nested": {
              "secure_contact_data": {
                "oneof": ["phone", "email"]
              }
            }
          },
          "ActivationPhone": {
            "fields": {
              "description": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "phone": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "RecoveryMethodScope": {
            "nested": {
              "RecoveryMethod": {
                "values": {
                  "UNKNOWN": 0,
                  "ACTIVATION_PHONE": 1,
                  "NEW_PHONE": 2,
                  "IDENTITY_VERIFICATION_PHONE": 3
                }
              }
            }
          },
          "RecoveryReasonScope": {
            "nested": {
              "RecoveryReason": {
                "values": {
                  "DORMANT_RECOVERY": 0,
                  "MANDATORY_2FA": 1,
                  "ATO_SELF_SERVE_RECOVERY": 2,
                  "STEP_UP_AUTHENTICATION": 3
                }
              }
            }
          },
          "RecoveryDetails": {
            "fields": {
              "activationPhone": {
                "type": "squareup.multipass.ActivationPhone",
                "id": 1
              }
            },
            "nested": {
              "recovery_data": {
                "oneof": ["activationPhone"]
              }
            }
          },
          "LaunchpadMerchantItem": {
            "fields": {
              "name": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "token": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "url": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "unitCount": {
                "type": "int64",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "LaunchpadServiceItem": {
            "fields": {
              "type": {
                "type": "squareup.multipass.LaunchpadServiceItem.LaunchpadServiceType",
                "id": 1,
                "rule": "optional"
              },
              "url": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "LaunchpadServiceType": {
                "values": {
                  "UNKNOWN": 0,
                  "PAYSTUBS": 1,
                  "BANKING": 2
                }
              }
            }
          },
          "TwoFactorVerificationSourceScope": {
            "nested": {
              "TwoFactorVerificationSource": {
                "values": {
                  "UNKNOWN": 0,
                  "LOGIN": 1,
                  "STEP_UP_AUTHENTICATION": 2,
                  "CHANGE_2FA_SETTINGS": 3,
                  "LOGIN_TWO_FACTOR_BYPASS": 4,
                  "PASSKEY_REGISTRATION": 5,
                  "PASSKEY_DEREGISTRATION": 6,
                  "SCA_VERIFICATION": 7,
                  "PASSKEY_LOGIN_TWO_FACTOR_BYPASS": 8
                }
              }
            }
          },
          "TwoFactorEnrollmentSource": {
            "values": {
              "UNKNOWN": 0,
              "ACCOUNT_SETTINGS": 1,
              "LOG_IN_REQUIREMENT": 2,
              "TWO_FACTOR_PROMO_PROMPT": 3,
              "CHECKING": 4,
              "PAYROLL": 5,
              "IDV": 6,
              "DORMANT_RECOVERY": 7,
              "MANDATORY_ENROLLMENT": 8,
              "MANDATORY_PROMO_PROMPT": 9,
              "ATO_SELF_SERVE_RECOVERY": 10,
              "STEP_UP_AUTHENTICATION": 11
            }
          },
          "TwoFactorDetails": {
            "fields": {
              "description": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "setTrustedDevice": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              },
              "createdAt": {
                "type": "int64",
                "id": 5,
                "rule": "optional"
              },
              "updatedAt": {
                "type": "int64",
                "id": 7,
                "rule": "optional"
              },
              "publicId": {
                "type": "string",
                "id": 8,
                "rule": "optional"
              },
              "sms": {
                "type": "squareup.multipass.SmsTwoFactor",
                "id": 2
              },
              "googleauth": {
                "type": "squareup.multipass.GoogleauthTwoFactor",
                "id": 4
              },
              "webauthn": {
                "type": "squareup.multipass.WebauthnTwoFactor",
                "id": 6
              },
              "email": {
                "type": "squareup.multipass.EmailTwoFactor",
                "id": 9
              }
            },
            "nested": {
              "two_factor_data": {
                "oneof": ["sms", "googleauth", "webauthn", "email"]
              }
            }
          },
          "SmsTwoFactor": {
            "fields": {
              "phone": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "verificationCode": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "deliveryMethod": {
                "type": "squareup.common.twofactor.TwoFactorDeliveryMethod",
                "id": 3,
                "rule": "optional",
                "options": {
                  "default": "SMS"
                }
              },
              "messagingBlocked": {
                "type": "bool",
                "id": 4,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "eligibleForSecureContactDetailEnrollment": {
                "type": "bool",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "GoogleauthTwoFactor": {
            "fields": {
              "verificationCode": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "authenticatorKeyBase32": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "accountName": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "authenticatorKeyUri": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "WebauthnTwoFactor": {
            "fields": {
              "credentialId": {
                "type": "bytes",
                "id": 1,
                "rule": "optional"
              },
              "signatureCount": {
                "type": "int64",
                "id": 2,
                "rule": "optional"
              },
              "signature": {
                "type": "bytes",
                "id": 3,
                "rule": "optional"
              },
              "encryptedData": {
                "type": "bytes",
                "id": 4,
                "rule": "optional"
              },
              "publicKeyCredential": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "challenge": {
                "type": "bytes",
                "id": 6,
                "rule": "optional"
              },
              "personToken": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              }
            }
          },
          "EmailTwoFactor": {
            "fields": {
              "email": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "verificationCode": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "Device": {
            "nested": {
              "Type": {
                "values": {
                  "DO_NOT_USE": 0,
                  "WEB": 1,
                  "MOBILE": 2
                }
              }
            }
          },
          "ScopedSession": {
            "values": {
              "SQUARE": 0,
              "CAPITAL_PARTNERSHIPS": 1,
              "BUYER": 2,
              "CAPITAL_CONSUMER": 3,
              "HIRING_WEB": 4,
              "SQUARE_BUYER": 5
            }
          },
          "CaptchaTypeScope": {
            "nested": {
              "CaptchaType": {
                "values": {
                  "UNKNOWN": 0,
                  "RECAPTCHA_V2_CHECKBOX": 1,
                  "RECAPTCHA_V2_ANDROID": 2,
                  "APPLE_DEVICECHECK": 3,
                  "SQUID_MCAP": 4,
                  "RECAPTCHA_ENTERPRISE_V2_CHECKBOX": 5,
                  "RECAPTCHA_ENTERPRISE_V3_WEB": 6,
                  "RECAPTCHA_ENTERPRISE_V3_ANDROID": 7
                }
              }
            }
          },
          "ResetPasswordLinkQueryParams": {
            "fields": {
              "returnTo": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "app": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "PasskeyCredential": {
            "fields": {
              "credentialId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "publicKeyCredential": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "createdAt": {
                "type": "int64",
                "id": 3,
                "rule": "optional"
              },
              "operatingSystem": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "agent": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "deviceType": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "name": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "metadata": {
                "type": "string",
                "id": 8,
                "rule": "optional"
              },
              "aaguid": {
                "type": "string",
                "id": 9,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.multipass?.nested?.SecureContactDetails && !$root.nested?.squareup?.nested?.multipass?.nested?.ActivationPhone && !$root.nested?.squareup?.nested?.multipass?.nested?.RecoveryMethodScope?.nested?.RecoveryMethod && !$root.nested?.squareup?.nested?.multipass?.nested?.RecoveryReasonScope?.nested?.RecoveryReason && !$root.nested?.squareup?.nested?.multipass?.nested?.RecoveryDetails && !$root.nested?.squareup?.nested?.multipass?.nested?.LaunchpadMerchantItem && !$root.nested?.squareup?.nested?.multipass?.nested?.LaunchpadServiceItem && !$root.nested?.squareup?.nested?.multipass?.nested?.LaunchpadServiceItem?.nested?.LaunchpadServiceType && !$root.nested?.squareup?.nested?.multipass?.nested?.TwoFactorVerificationSourceScope?.nested?.TwoFactorVerificationSource && !$root.nested?.squareup?.nested?.multipass?.nested?.TwoFactorEnrollmentSource && !$root.nested?.squareup?.nested?.multipass?.nested?.TwoFactorDetails && !$root.nested?.squareup?.nested?.multipass?.nested?.SmsTwoFactor && !$root.nested?.squareup?.nested?.multipass?.nested?.GoogleauthTwoFactor && !$root.nested?.squareup?.nested?.multipass?.nested?.WebauthnTwoFactor && !$root.nested?.squareup?.nested?.multipass?.nested?.EmailTwoFactor && !$root.nested?.squareup?.nested?.multipass?.nested?.Device?.nested?.Type && !$root.nested?.squareup?.nested?.multipass?.nested?.ScopedSession && !$root.nested?.squareup?.nested?.multipass?.nested?.CaptchaTypeScope?.nested?.CaptchaType && !$root.nested?.squareup?.nested?.multipass?.nested?.ResetPasswordLinkQueryParams && !$root.nested?.squareup?.nested?.multipass?.nested?.PasskeyCredential) {
  $root.addJSON(jsonData);
}

/**
 * All the data about a single secure contact method.
 *
 * SOURCE SecureContactDetails @ squareup/multipass/common.proto at 81:1
 */
export const SecureContactDetails = $root.lookupType('squareup.multipass.SecureContactDetails');
fixType(SecureContactDetails);
Builder.createAndAttachToType(SecureContactDetails);
/**
 * Activation phone supplied at the time of payment onboarding/IDV. Sourced from Onboarding.
 *
 * SOURCE ActivationPhone @ squareup/multipass/common.proto at 103:1
 */
export const ActivationPhone = $root.lookupType('squareup.multipass.ActivationPhone');
fixType(ActivationPhone);
Builder.createAndAttachToType(ActivationPhone);
/**
 * Recovery method type for recovering an account.
 *
 * SOURCE RecoveryMethodScope @ squareup/multipass/common.proto at 112:1
 */
export const RecoveryMethodScope = {};
/**
 * SOURCE RecoveryMethod @ squareup/multipass/common.proto at 113:3
 */
RecoveryMethodScope.RecoveryMethod = $root.lookupEnum('squareup.multipass.RecoveryMethodScope.RecoveryMethod').values;
/**
 * Recovery reason for distinguishing the reason a recovery event was requested.
 *
 * SOURCE RecoveryReasonScope @ squareup/multipass/common.proto at 143:1
 */
export const RecoveryReasonScope = {};
/**
 * SOURCE RecoveryReason @ squareup/multipass/common.proto at 144:3
 */
RecoveryReasonScope.RecoveryReason = $root.lookupEnum('squareup.multipass.RecoveryReasonScope.RecoveryReason').values;
/**
 * All the data about a recovery detail.
 *
 * SOURCE RecoveryDetails @ squareup/multipass/common.proto at 160:1
 */
export const RecoveryDetails = $root.lookupType('squareup.multipass.RecoveryDetails');
fixType(RecoveryDetails);
Builder.createAndAttachToType(RecoveryDetails);
/**
 * The merchant item displayed on Launchpad page
 *
 * SOURCE LaunchpadMerchantItem @ squareup/multipass/common.proto at 198:1
 */
export const LaunchpadMerchantItem = $root.lookupType('squareup.multipass.LaunchpadMerchantItem');
fixType(LaunchpadMerchantItem);
Builder.createAndAttachToType(LaunchpadMerchantItem);
/**
 * The service item displayed on Launchpad page
 *
 * SOURCE LaunchpadServiceItem @ squareup/multipass/common.proto at 213:1
 */
export const LaunchpadServiceItem = $root.lookupType('squareup.multipass.LaunchpadServiceItem');
fixType(LaunchpadServiceItem);
Builder.createAndAttachToType(LaunchpadServiceItem);
/**
 * The type of the service
 *
 * SOURCE LaunchpadServiceType @ squareup/multipass/common.proto at 221:3
 */
LaunchpadServiceItem.LaunchpadServiceType = $root.lookupEnum('squareup.multipass.LaunchpadServiceItem.LaunchpadServiceType').values;
/**
 * SOURCE TwoFactorVerificationSourceScope @ squareup/multipass/common.proto at 232:1
 */
export const TwoFactorVerificationSourceScope = {};
/**
 * SOURCE TwoFactorVerificationSource @ squareup/multipass/common.proto at 233:3
 */
TwoFactorVerificationSourceScope.TwoFactorVerificationSource = $root.lookupEnum('squareup.multipass.TwoFactorVerificationSourceScope.TwoFactorVerificationSource').values;
/**
 * SOURCE TwoFactorEnrollmentSource @ squareup/multipass/common.proto at 263:1
 */
export const TwoFactorEnrollmentSource = $root.lookupEnum('squareup.multipass.TwoFactorEnrollmentSource').values;
/**
 * All the data about a single method of 2FA.
 *
 * SOURCE TwoFactorDetails @ squareup/multipass/common.proto at 347:1
 */
export const TwoFactorDetails = $root.lookupType('squareup.multipass.TwoFactorDetails');
fixType(TwoFactorDetails);
Builder.createAndAttachToType(TwoFactorDetails);
/**
 * SOURCE SmsTwoFactor @ squareup/multipass/common.proto at 383:1
 */
export const SmsTwoFactor = $root.lookupType('squareup.multipass.SmsTwoFactor');
fixType(SmsTwoFactor);
Builder.createAndAttachToType(SmsTwoFactor);
/**
 * SOURCE GoogleauthTwoFactor @ squareup/multipass/common.proto at 406:1
 */
export const GoogleauthTwoFactor = $root.lookupType('squareup.multipass.GoogleauthTwoFactor');
fixType(GoogleauthTwoFactor);
Builder.createAndAttachToType(GoogleauthTwoFactor);
/**
 * SOURCE WebauthnTwoFactor @ squareup/multipass/common.proto at 428:1
 */
export const WebauthnTwoFactor = $root.lookupType('squareup.multipass.WebauthnTwoFactor');
fixType(WebauthnTwoFactor);
Builder.createAndAttachToType(WebauthnTwoFactor);
/**
 * Email 2FA details. Currently only a valid 2FA method for 2FA Upgrades/Verifications.
 *
 * SOURCE EmailTwoFactor @ squareup/multipass/common.proto at 471:1
 */
export const EmailTwoFactor = $root.lookupType('squareup.multipass.EmailTwoFactor');
fixType(EmailTwoFactor);
Builder.createAndAttachToType(EmailTwoFactor);
/**
 * SOURCE Device @ squareup/multipass/common.proto at 489:1
 */
export const Device = {};
/**
 * SOURCE Type @ squareup/multipass/common.proto at 490:3
 */
Device.Type = $root.lookupEnum('squareup.multipass.Device.Type').values;
/**
 * Scoped session type that indicates from where / how the session should be validated.
 *
 * SOURCE ScopedSession @ squareup/multipass/common.proto at 623:1
 */
export const ScopedSession = $root.lookupEnum('squareup.multipass.ScopedSession').values;
/**
 * Types of captcha that can be verified.
 *
 * SOURCE CaptchaTypeScope @ squareup/multipass/common.proto at 659:1
 */
export const CaptchaTypeScope = {};
/**
 * SOURCE CaptchaType @ squareup/multipass/common.proto at 660:3
 */
CaptchaTypeScope.CaptchaType = $root.lookupEnum('squareup.multipass.CaptchaTypeScope.CaptchaType').values;
/**
 * Additional query params that should be added as part of the password reset link.
 *
 * SOURCE ResetPasswordLinkQueryParams @ squareup/multipass/common.proto at 779:1
 */
export const ResetPasswordLinkQueryParams = $root.lookupType('squareup.multipass.ResetPasswordLinkQueryParams');
fixType(ResetPasswordLinkQueryParams);
Builder.createAndAttachToType(ResetPasswordLinkQueryParams);
/**
 * Passkey credential object as exposed by multipass and multipassfe APIs
 *
 * SOURCE PasskeyCredential @ squareup/multipass/common.proto at 815:1
 */
export const PasskeyCredential = $root.lookupType('squareup.multipass.PasskeyCredential');
fixType(PasskeyCredential);
Builder.createAndAttachToType(PasskeyCredential);